import { merchantApi } from '@/config/axios'

/**
 * 商家端 - 商品分类 API
 * list：仅返回当前店铺经营类目范围内的分类（含祖先/子类，供发品级联）
 */
export interface CategoryVO {
  id?: number
  parentId?: number
  name: string
  picUrl: string
  sort: number
  status: number
  defaultCommissionRate?: number
}

// 获得商品分类列表
export const getCategoryList = (params: any) => {
  return merchantApi.get({ url: '/merchant-api/product/category/list', params })
}
